const bankNames = [
  {
    value:         '1',
    text:          'Banco do Brasil',
    incomeSources: [
      'Full-time',
      'Government',
      'Self-employed',
      'Informal',
      'Retired',
      'Other',
    ],
  },
  {
    value:         '237',
    text:          'Bradesco',
    incomeSources: [
      'Full-time',
      'Government',
      'Self-employed',
      'Informal',
      'Retired',
      'Other',
    ],
  },
  {
    value:         '104',
    text:          'Caixa',
    incomeSources: [
      'Full-time',
      'Government',
      'Self-employed',
      'Informal',
      'Retired',
      'Other',
    ],
  },
  {
    value:         '341',
    text:          'Itaú',
    incomeSources: [
      'Full-time',
      'Government',
      'Self-employed',
      'Informal',
      'Retired',
      'Other',
    ],
  },
  {
    value:         '33',
    text:          'Santander',
    incomeSources: [
      'Full-time',
      'Government',
      'Self-employed',
      'Informal',
      'Retired',
      'Other',
    ],
  },
];
export default bankNames;
